import { render, staticRenderFns } from "./horizontalinput.vue?vue&type=template&id=89aff814&scoped=true&"
import script from "./horizontalinput.vue?vue&type=script&lang=js&"
export * from "./horizontalinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89aff814",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89aff814')) {
      api.createRecord('89aff814', component.options)
    } else {
      api.reload('89aff814', component.options)
    }
    module.hot.accept("./horizontalinput.vue?vue&type=template&id=89aff814&scoped=true&", function () {
      api.rerender('89aff814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/horizontalinput.vue"
export default component.exports